module.exports = __webpack_public_path__ + "static/media/slideshow-3.20ccb22f.jpg";